import React, { useEffect, useState } from 'react';
import LanguageSwitcher from './LanguageSwitcher';
import useGame from '../hooks/useGame';
import KeyVideo_LT_LT from '../assets/video/key_videos/lt-lt.mp4';
import KeyVideo_ET_ET from '../assets/video/key_videos/et-et.mp4';
import KeyVideo_ET_RU from '../assets/video/key_videos/et-ru.mp4';
import KeyVideo_LV_LV from '../assets/video/key_videos/lv-lv.mp4';
import KeyVideo_LV_RU from '../assets/video/key_videos/lv-ru.mp4';
import { useTranslation } from 'react-i18next';
import gameStates from '../helpers/gameState';

const Header = () => {
  const { t } = useTranslation();
  const { REACT_APP_LANGUAGE, REACT_APP_SEB_URL, REACT_APP_SEB_URL_RU, REACT_APP_UTM_ABOUT  } = process.env;
  const { toggleAudioState, navigateToAccessiblePageVersion, isPlayingBackgroundMusic, language } = useGame();
  const [keyVideo, setKeyVideo] = useState(KeyVideo_ET_ET);
  const { gameState } = useGame();

  useEffect(() => {
    document.querySelector('html').setAttribute('language', `${REACT_APP_LANGUAGE}-${language}`)
    const popup = document.querySelector('#about-container');
    if(REACT_APP_LANGUAGE === 'et' && language === 'et'){
      setKeyVideo(KeyVideo_ET_ET);
    }
    if(REACT_APP_LANGUAGE === 'et' && language === 'ru'){
      setKeyVideo(KeyVideo_ET_RU);
    }
    if(REACT_APP_LANGUAGE === 'lt' && language === 'lt'){
      setKeyVideo(KeyVideo_LT_LT);
    }
    if(REACT_APP_LANGUAGE === 'lv' && language === 'lv'){
      setKeyVideo(KeyVideo_LV_LV);
    }
    if(REACT_APP_LANGUAGE === 'lv' && language === 'ru'){
      setKeyVideo(KeyVideo_LV_RU);
    }
  }, [REACT_APP_LANGUAGE, language]);

  return (
    <>
      <span className="logo" />
      <header>
        <div className="user">
          <LanguageSwitcher />
          {gameState === gameStates.INTRO && <span tabIndex={0}
            role="button"
            aria-label={t('header.accessible_version')}
            href="https://www.seb.lt/sites/default/files/calc/Cybersecurity-accessible/browser/index.html"
            onClick={(evt) => navigateToAccessiblePageVersion(evt)}
            onKeyDown={(evt) => navigateToAccessiblePageVersion(evt)}
            className="icon accessible" >
          </span>}          
          {!isPlayingBackgroundMusic && (
            <span tabIndex={0} id="sound-top" role='button'
              onClick={(evt) => toggleAudioState(evt)}
              onKeyDown={(evt) => toggleAudioState(evt)}
              className="icon sound-mute sound-top" />
          )}
          {isPlayingBackgroundMusic && (
            <span tabIndex={0} id="sound-top" role='button'
              onClick={(evt) => toggleAudioState(evt)}
              onKeyDown={(evt) => toggleAudioState(evt)}
              className="icon sound sound-top" />
          )}
          <div className="menu">
            <div role='button' tabIndex={0} id="menu-button">
              <span />
            </div>
            <div id="nav-container">
              <span role='button' tabIndex={0} className="icon close-nav" />
              <nav>
                <a href="#" data-action="about" id="about-a">{t('about.title')}</a>
                <a href={language === 'ru' ? REACT_APP_SEB_URL_RU+REACT_APP_UTM_ABOUT : REACT_APP_SEB_URL+REACT_APP_UTM_ABOUT} target="_blank">{t('security.title')}</a>
              </nav>
            </div>
            <div id="about-container">
              <div className="inner">
                <h2>{t('about.title')}</h2>
                <p>{t('about.text')}</p>
                <button tabIndex={0} id="about-video" className="default" data-video={keyVideo}>{t('about.watch_video')}</button>
              </div>
              <span role='button' tabIndex={0} className="icon close-nav" />
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
